import { render, staticRenderFns } from "./NewDiscount.vue?vue&type=template&id=75aa1aa6&scoped=true&"
import script from "./NewDiscount.vue?vue&type=script&lang=js&"
export * from "./NewDiscount.vue?vue&type=script&lang=js&"
import style0 from "./NewDiscount.vue?vue&type=style&index=0&id=75aa1aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa1aa6",
  null
  
)

export default component.exports